import { h } from 'preact';
import { useMemo } from 'preact/compat';
import { decodeEntities } from '@wordpress/html-entities';
import { WPConfig, Candidate } from '../types';
import { useCart, CartSelectionMap, formatCurrency } from '../hooks/cart';
import { useDonationStep, DonationStepEnum, StepAction } from '../hooks/step';
import purifyHTML from '../lib/purify';
import AmountButtonGroup from './inputs/AmountButtonGroup';
import { validCheckoutTransition } from '../hooks/transitionGaurds';
import { randomColorVar } from '../lib/helpers';
import Image, { Fallback } from './Image';

/**
 * Always present image.
 */
export const IndividualImage = ({
	candidate,
}:{
	candidate: Candidate;
}) => {
	const color = useMemo(() => randomColorVar(), []);

	return (
		<div
			className="ea-individual__image"
			style={{
				'--ea-auto-color': `var(${color})`,
			}}
		>
			{candidate.image ? (
				<Image
					{...candidate.image}
					width={500}
					height={500}
					loading="eager"
				/>
			) : (
				<Fallback />
			)}
		</div>
	);
};

const IndividualSelectGroup = ({
	theme,
	candidate,
	selections,
	dispatch,
}: {
	theme: WPConfig;
	candidate: Candidate;
	selections: CartSelectionMap;
	dispatch: StepAction;
}) => (
	<div className="ea-individual__intro-init">
		{theme.desc && (
			<div className="ea-individual__intro-desc" dangerouslySetInnerHTML={{ __html: purifyHTML(theme.desc) }} />
		)}
		<span className="ea-individual__intro-label">Choose an amount to give.</span>
		<AmountButtonGroup
			target={candidate}
			key={candidate.id}
			count={3}
		/>
		<button
			className={[
				'ea-btn',
				'ea-btn--lg',
				'ea-individual__intro-btn',
				selections.size > 0 ? '' : 'ea-btn--invert',
			].join(' ')}
			type="button"
			// Must have selections.
			disabled={!validCheckoutTransition()}
			onClick={() => {
				dispatch({
					type: 'MANUAL_STEP',
					payload: {
						step: DonationStepEnum.CHECKOUT,
					},
				});
			}}
		>
			<span>Donate</span>
		</button>
		<p className="ea-small">
			Minimum $3,
			maximum
			{' '}
			{formatCurrency(candidate.contribution_limit)}
		</p>
	</div>
);

/**
 * Individual Top.
 */
const IndividualShopping = ({
	theme,
	candidate,
}:{
	theme: WPConfig;
	candidate: Candidate;
}) => {
	const { dispatch, state } = useDonationStep();
	const { cart } = useCart();
	const { selections } = cart;

	const {
		title,
	} = theme;

	return (
		<div className="ea-individual__top">
			<div className="ea-individual__intro">
				{title && (
					<h2 className="h1 ea-individual__name ea-alt-title">
						{decodeEntities(title)}
					</h2>
				)}
				{state === DonationStepEnum.ENTRY && (
					<IndividualSelectGroup
						theme={theme}
						candidate={candidate}
						selections={selections}
						dispatch={dispatch}
					/>
				)}
			</div>
		</div>
	);
};

export default IndividualShopping;
